import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import styled from "styled-components";
import Logo from "./Logo";
import NotificationAndProfile from "./NotificationAndProfile";
import Sidebar from "../Sidebar";
import LogoutModal from "../ModalPages/LogoutModal";
import UserNotification from "../UserNotification";

const hamburgerIcon = require("../../assets/images/hamburger_menu.png");
const bellIcon = require("../../assets/images/notif_bell_white.png");

const Topbar = ({ activePath, onRoute, showBizTripTutorial, hideBizTrip }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const handleResize = () => {
    if (window.innerWidth > 768) {
      setShowSidebar(false);
    }
  };
  const onLogoutClose = () => {
    setOpenLogoutModal(false);
  };
  const showHideSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);

  return (
    <TopbarContainer>
      <Logo />
      <NavbarNotifProfile>
        <Navbar
          hideBizTrip={hideBizTrip}
          activePath={activePath}
          onRoute={onRoute}
          showBizTripTutorial={showBizTripTutorial}
        />
        <NotificationAndProfile
          openLogoutModal={openLogoutModal}
          setOpenLogoutModal={setOpenLogoutModal}
        />
      </NavbarNotifProfile>
      <ResponsiveMobileView>
        <div>
          <UserNotification src={bellIcon} />
        </div>
        <div>
          <HamburgerIcon
            src={hamburgerIcon}
            alt="menu"
            onClick={showHideSidebar}
          />
        </div>
      </ResponsiveMobileView>
      {openLogoutModal && <LogoutModal setClose={onLogoutClose} />}
      {showSidebar && (
        <Sidebar
          hideBizTrip={hideBizTrip}
          onClose={showHideSidebar}
          activePath={activePath}
          onRoute={onRoute}
          setOpenLogoutModal={setOpenLogoutModal}
        />
      )}
    </TopbarContainer>
  );
};

export default Topbar;

const TopbarContainer = styled.div`
  padding: 1.5rem 2.25rem 1rem 2.25rem;
  display: grid;
  grid-template-columns: 1fr 6fr;
  align-items: center;
  background: transparent;
  gap: 7rem;
  height: 4rem;
  @media only screen and (max-width: 900px) {
    gap: 2.5rem;
  }
  @media only screen and (max-width: 768px) {
    gap: 2rem;
    background: linear-gradient(
      270.03deg,
      #071a29 0.03%,
      #132736 48.23%,
      #091d2b 99.98%
    );
  }
`;
const NavbarNotifProfile = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
const ResponsiveMobileView = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;
const HamburgerIcon = styled.img`
  cursor: pointer;
`;
